import { Hero } from '../components/marketing/Hero';
import { Problem, Operator, EditorialMarquee, Specialists, Ownership } from '../components/marketing/ProductSections';
import { Verification, HowItWorks, Access, Token, WhitepaperCallout } from '../components/marketing/WorkSections';
import { FAQ, FinalCTA } from '../components/marketing/ClosingSections';

export default function Home() {
  return <main id="main-content" tabIndex={-1} data-testid="homepage">
    <Hero /><Problem /><Operator /><EditorialMarquee /><Specialists /><Ownership />
    <Verification /><HowItWorks /><Access /><Token /><WhitepaperCallout /><FAQ /><FinalCTA />
  </main>;
}